import React from "react";
import PropTypes from "prop-types";
import { useAppInfo } from "../../../../helpers/hooks/common-hook";

const Header = ({ children }) => {
  const appInfo = useAppInfo();
  return (
    <header
      className="
      fixed top-0 inset-x-0 z-10 border-b border-gray-200
      dark:border-b-gray-700 bg-white dark:bg-slate-950"
    >
      <nav
        className="
        w-full 
        pl-20 pr-4 
        p-4 
        h-14 
        flex 
        items-center 
        justify-between"
      >
        <div className="flex items-center gap-0 min-w-0">
          <span className="font-semibold text-base tracking-wide text-gray-800 dark:text-gray-100 truncate">
            {appInfo?.name || "BotCircuits"}
          </span>
        </div>
        <div className="flex items-center">
          {children}
        </div>
      </nav>
    </header>
  );
};

export default Header;

Header.propTypes = {
  children: PropTypes.any,
};
